module.exports = __webpack_public_path__ + "static/img/92070B_2_C_20200913_LC.65558a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/92070B_2_C_20200913_LC.png
// module id = bact
// module chunks = 0